import "./template_promotions_single.css";
